var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBloodClot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "71px",
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2FA80BBB-BAD2-495D-8817-C2C62F9E2130") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7---Warnings-and-precautions-for-Hana-",
    transform: "translate(-537.000000, -179.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(539.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.036395,33.5181 C67.036395,52.02975 52.029795,67.03635 33.518145,67.03635 C15.006645,67.03635 4.5e-05,52.02975 4.5e-05,33.5181 C4.5e-05,15.0066 15.006645,0 33.518145,0 C52.029795,0 67.036395,15.0066 67.036395,33.5181 Z",
    id: "Stroke-1",
    stroke: "#222456",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.21101,19.85667 C28.95696,19.85667 29.56131,19.25202 29.56131,18.50592 C29.56131,17.75982 28.95606,17.15517 28.21011,17.15517 C27.46416,17.15517 26.85936,17.75982 26.85936,18.50592 C26.85936,19.25202 27.46416,19.85667 28.21011,19.85667 L28.21101,19.85667 Z",
    id: "Fill-3",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.54175,51.452475 C39.2877,51.452475 39.89205,50.847825 39.89205,50.101725 C39.89205,49.355625 39.2868,48.750975 38.54085,48.750975 C37.7949,48.750975 37.1901,49.355625 37.1901,50.101725 C37.1901,50.847825 37.7949,51.452475 38.54085,51.452475 L38.54175,51.452475 Z",
    id: "Fill-5",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.913065,48.982305 C31.659015,48.982305 32.263365,48.377655 32.263365,47.631555 C32.263365,46.885455 31.658115,46.280805 30.912165,46.280805 C30.166065,46.280805 29.561415,46.885455 29.561415,47.631555 C29.561415,48.377655 30.166215,48.982305 30.912165,48.982305 L30.913065,48.982305 Z",
    id: "Fill-7",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.83977,17.42664 C36.58557,17.42664 37.19007,16.82184 37.19007,16.07589 C37.19007,15.32979 36.58482,14.72499 35.83887,14.72499 C35.09277,14.72499 34.48797,15.32979 34.48797,16.07589 C34.48797,16.82184 35.09292,17.42664 35.83887,17.42664 L35.83977,17.42664 Z",
    id: "Fill-9",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.54175,22.55814 C39.2877,22.55814 39.89205,21.95349 39.89205,21.20739 C39.89205,20.46129 39.2868,19.85664 38.54085,19.85664 C37.7949,19.85664 37.1901,20.46129 37.1901,21.20739 C37.1901,21.95349 37.7949,22.55814 38.54085,22.55814 L38.54175,22.55814 Z",
    id: "Fill-11",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.913065,56.07567 C31.659015,56.07567 32.263365,55.47102 32.263365,54.72492 C32.263365,53.97882 31.658115,53.37417 30.912165,53.37417 C30.166065,53.37417 29.561415,53.97882 29.561415,54.72492 C29.561415,55.47102 30.166215,56.07567 30.912165,56.07567 L30.913065,56.07567 Z",
    id: "Fill-13",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83692,33.5181 C41.83692,38.11245 38.11242,41.83695 33.51822,41.83695 C28.92387,41.83695 25.19952,38.11245 25.19952,33.5181 C25.19952,28.9239 28.92387,25.1994 33.51822,25.1994 C38.11242,25.1994 41.83692,28.9239 41.83692,33.5181 Z",
    id: "Stroke-15",
    stroke: "#EE7330",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.91736,58.31292 L43.91736,43.05912 C46.22346,40.54692 47.63151,37.19712 47.63151,33.51807 C47.63151,29.83932 46.22346,26.48952 43.91736,23.97732 L43.91736,8.72337",
    id: "Stroke-17",
    stroke: "#222456",
    strokeWidth: 1.89105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.220795,8.723415 L23.220795,23.868015 C20.854545,26.391915 19.404795,29.785515 19.404795,33.518115 C19.404795,37.250865 20.854545,40.644465 23.220795,43.168365 L23.220795,58.312965",
    id: "Stroke-19",
    stroke: "#222456",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodClot);
export default __webpack_public_path__ + "static/media/bloodClot.e01520fa.svg";
export { ForwardRef as ReactComponent };